import { createContext, useContext, useState, useCallback } from "react";
import { detailText } from "../utils/apiErrors";

const NotificationContext = createContext(null);

const MAX_FEED = 5;

export function NotificationProvider({ children }) {
  const [feed, setFeed] = useState([]);

  const addNotification = useCallback((rawMessage, type = "info", url = null, sender = null) => {
    const id = `notif-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    // Callers pass `error.response.data.detail` straight in (100+ places) and the API sometimes answers with an
    // OBJECT detail ({message} / {code}). The feed is rendered as a JSX child by the sidebar, which sits outside
    // every ErrorBoundary, so an object here would unmount the whole app: always store text.
    const message = rawMessage && typeof rawMessage === "object" ? detailText(rawMessage) : rawMessage;

    setFeed((prev) =>
      [{ id, message, type, url, sender, timestamp: Date.now(), isNew: true }, ...prev].slice(0, MAX_FEED)
    );

    setTimeout(() => {
      setFeed((prev) => prev.map((n) => (n.id === id ? { ...n, isNew: false } : n)));
    }, 10_000);
  }, []);

  return (
    <NotificationContext.Provider value={{ addNotification, feed }}>
      {children}
    </NotificationContext.Provider>
  );
}

export const useNotification = () => {
  const ctx = useContext(NotificationContext);
  if (!ctx) console.error("[Notifications] useNotification called outside NotificationProvider!");
  return ctx ?? { addNotification: () => {}, feed: [] };
};
